import { useEffect } from 'react';
import {
    LinkedinShareButton,
    LinkedinIcon,
} from 'next-share';

export const LinkedinShareTemplate = ({ pageUrl, pageTitle }) => {
    useEffect(() => {
        // Add `rel="nofollow"` to the first anchor tag in this component
        const shareLinks = document.querySelectorAll('.linkedin-share-button button');
        shareLinks.forEach((link) => {
            link.setAttribute('rel', 'nofollow');
        });
    }, []);
    return (
        <div className="linkedin-share-button">
            <LinkedinShareButton url={pageUrl} quote={pageTitle} >
                <LinkedinIcon size={44} round />
            </LinkedinShareButton>
        </div>
    );
}